class BasicTimer {
    constructor(timerInstance) {
        this.timerInstance = timerInstance;
    }
    getTimerInstance() {
        return this.timerInstance;
    }
}

export default BasicTimer;